import * as React from 'react';
export const MenuPortalContext = /*#__PURE__*/React.createContext(undefined);
export function useMenuPortalContext() {
  const value = React.useContext(MenuPortalContext);
  if (value === undefined) {
    throw new Error('Base UI: <Menu.Portal> is missing.');
  }
  return value;
}